(($) => {
    const windowWidth = $(window).width();
    const posts = $('.posts.paginatedContainer, .products_list.paginatedContainer, .lp-product-list');
    let itemsPerPage = windowWidth > 1920 ? 15 : windowWidth > 1300 ? 12 : windowWidth > 992 ? 9 : 6;

    if ($('.products_list_container').length > 0) {
        itemsPerPage = windowWidth > 2559 ? 25 : windowWidth > 1919 ? 20 : windowWidth > 1299 ? 16 :  windowWidth > 767 ? 12 : 8;
    }

    if ($('.lp-product-list').length > 0) {
        itemsPerPage = windowWidth > 991 ? 24 : windowWidth > 767 ? 15 :  8;
    }

    if (posts.length) {
        let postItems = posts.find('.posts__item, .tease_product');

        if (postItems.length === 0) {
            postItems = posts.find(posts.find('.product-card'));
        }

        if(postItems.length) {
            const totalPages = Math.ceil(postItems.length / itemsPerPage);
            let currentPage = 1;

            postItems.slice(0, itemsPerPage).addClass('make_visible');
            postItems.slice(0, itemsPerPage).addClass('visible');

            const loadMore = $('.posts__loadMore');
            if (totalPages > 1) {
                loadMore.addClass('flex').removeClass('hidden');
            }
            const postCount = $('.posts_loaded');
            const showingPosts = postCount.find('.showing').text(itemsPerPage);
            postCount.find('.count').text(postItems.length);
            const showingPostsBar = $('.posts_loaded--bar');
            const progressBar = showingPostsBar.find('.progerss');
            let barWidth = (itemsPerPage / postItems.length) * 100;
            progressBar.width(`${barWidth}%`);

            $('.posts__loadMore button').on('click', function() {
                currentPage++;
                postItems.slice(0, currentPage * itemsPerPage).addClass('make_visible');
                postItems.slice(0, currentPage * itemsPerPage).addClass('visible');
                
                if (currentPage >= totalPages) {
                    loadMore.hide();
                }

                showingPosts.text(itemsPerPage * currentPage);
                barWidth = ((itemsPerPage * currentPage) / postItems.length) * 100;
                progressBar.width(`${barWidth}%`);
            });
        }
    }
    $('.loader-bg').hide();
    $('.loader-wrapper').hide();
})(jQuery);